module.exports = __webpack_public_path__ + "static/media/tuzoLogo.6d0cd2d3.png";